// helpers
const findLang = ({item, key, locale}) => {
  let $lang = Object.keys(item[key]).find(lang =>
    lang.indexOf(locale) > -1
  );
  if(!$lang) $lang = Object.keys(item[key])[0];

  return $lang;
}

/**
 * item.aaa, item.bbb, 指定 L1 語系
 * 若 aaa 有 L1 語系，則取代 aaa
 * 若 bbb 無 L1 語系，則用預設語系
 */
export const keepOneLocale = item => locale => {
  item = Object.keys(item).reduce((obj, key) => {
    if(!['id', 'link'].includes(key) && item[key]) {
      let $lang = findLang({item, key, locale});
      return {
        ...obj,
        [key]: item[key][$lang]
      }
    }

    return {
      ...obj,
      [key]: item[key]
    };
  }, {});

  if(item.image && item.image.fields && item.image.fields.file) {
    const $lang = findLang({
      locale,
      key: 'file',
      item: item.image.fields,
    });
    if(item.image.fields.file[$lang].url) {
      item.image = item.image.fields.file[$lang].url;
    }
  } else {
    item.image = "";
  }

  item.type = item.type.split(',');
  return item;
}

const filterCase = ({caseList, filter, during, locale}) => {
  const keyList = {};
  caseList = caseList.map(item => ({
    ...item,
    image: item.image ? item.image.fields.file.url: ""
  }));
  // caseList = caseList.map(item => keepOneLocale(item)(locale));

  // 篩選分類
  Object.keys(filter).filter(key => key !== 'keyword').forEach(key => {
    keyList[key] = filter[key].indexList.map(index =>
      filter[key].list[index]
    );
  });

  // 篩選出時間內的case，若選擇是今天，則列全部
  if(new Date(during.startDate).getTime() !== new Date(during.endDate).getTime()) {
    caseList = caseList.filter((work) => isDuring({ work, during }));
  }

  // 篩選關鍵字
  caseList = caseList.filter(item => {
    return (
      item.name.toUpperCase().indexOf(filter.keyword.toUpperCase()) > -1 ||
      item.intro.toUpperCase().indexOf(filter.keyword.toUpperCase()) > -1
    );
  });

  // 未選某個分類就設為全找
  return caseList.filter(item => {
    return (!keyList.type.length || keyList.type.some(kt => item.type.indexOf(kt) > -1 )) &&
    (!keyList.client.length || keyList.client.indexOf(item.client) > -1);
  });
};

// 是否在 range 內
const isDuring = ({ work, during }) => {
  work = {
    start: new Date(work.dateStart).getTime(),
    end: new Date(work.dateEnd).getTime(),
  }
  during = {
    start: new Date(during.startDate).getTime(),
    end: new Date(during.endDate).getTime(),
  }

  return (during.start >= work.start && during.start <= work.end) ||
         (during.end >= work.start && during.end <= work.end);
}

// 取得 type, clint 的 i18n 清單
const listLocaleMap = ({locale, caseList}) => {

  let typeList = [];
  let clientList = [];
  caseList.forEach(oriItem => {
    let item = oriItem;

    if(clientList.indexOf(item.client) === -1) {
      clientList.push(item.client);
    }
    item.type.forEach(t => {
      if(typeList.indexOf(t) === -1) {
        typeList.push(t);
      }
    });
  });

  return {
    typeList,
    clientList,
  };
};

export const mapEntry = ({item, locale}) => ({
  ...item.fields,
  id: item.sys.id,
  image: item.fields.image,
  link: `/${locale}/case/${item.sys.id}`,
  type: item.fields.type.split(','),
  // image: item.fields.image.fields.file.url,
  // link: `/${this.props.locale}/case/${item.sys.id}`
})

export {
  filterCase,
  listLocaleMap,
};



// WEBPACK FOOTER //
// ./src/pages/CasePage/helper.js